import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useAuth } from 'react-oidc-context'

const withAuthenticationRequired = (Component) =>
  function WithAuthenticationRequiredHOC(props) {
    const { isAuthenticated, isLoading } = useAuth()
    const {
      push,
      query: { code },
    } = useRouter()

    useEffect(() => {
      if (!isLoading && !isAuthenticated && !code) push('/login')
    }, [isLoading, isAuthenticated, code, push])

    return <Component {...props} />
  }

export default withAuthenticationRequired
